export const RESEND_USER_INVITE_REQUEST = "RESEND_USER_INVITE_REQUEST";
export const RESEND_USER_INVITE_RECEIVE = "RESEND_USER_INVITE_RECEIVE";
export const RESEND_USER_INVITE_FAILURE = "RESEND_USER_INVITE_FAILURE";
export const RESET_RESEND_USER_INVITE = "RESET_RESEND_USER_INVITE";
